import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {ARROW_RIGHT__24} from '@homeaway/svg-defs/lib/defs/ARROW_RIGHT__24';
import {SVGIcon} from '@homeaway/react-svg';
import StayContext from '../../../context/StayContext';
import translate from '../../../../utils/translations';
import {Countdown} from '../../Countdown/Countdown';

import './TripDateSummary.less';

const isDateValid = (date) => date && date !== '-';

export class TripDateSummary extends React.Component {
    static propTypes = {
        handelBannerClick: PropTypes.func,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        handelBannerClick: () => {},
        translations: {},
    };

    static contextType = StayContext;

    get stayContext() {
        if (!this.context) {
            throw new Error(
                'stayContext must be used within a StayContextProvider'
            );
        }
        return this.context;
    }

    render() {
        const {handelBannerClick, translations} = this.props;
        const {
            stay: {
                booking: {
                    checkin: {date: checkinDate, time: checkInTime},
                    checkout: {date: checkoutDate, time: checkOutTime},
                    reservationUuid,
                },
                unit: {url: unitUrl, location, listingId},
            },
        } = this.stayContext;

        return (
            <div className="TripDateSummary rounded-border">
                <Countdown
                    expirationDateTime={this.props.expirationDateTime}
                    translations={translations}
                />
                <div className="TripDateSummary__Property_Details">
                    {listingId && unitUrl && (
                        <Fragment>
                            <Link
                                className="Property_headline"
                                // eslint-disable-next-line react/jsx-no-bind
                                onClick={
                                    /* istanbul ignore next */ () =>
                                        handelBannerClick(
                                            reservationUuid,
                                            checkoutDate,
                                            checkinDate
                                        )
                                }
                                target="_blank"
                                to={unitUrl}
                            >
                                {location}
                            </Link>
                            <div className="booking-section__line">
                                <span>{`${translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.inbox.conversation.propertySummary.property.id'
                                )}: `}</span>
                                <span>{listingId}</span>
                            </div>
                        </Fragment>
                    )}
                </div>
                {isDateValid(checkinDate) && (
                    <div className="trip-dates-section">
                        <div className="trip-dates-section__arrival">
                            <div className="trip-dates-section__date_time">
                                <div>
                                    {translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'stay.amenity.checkin'
                                    )}
                                </div>
                                <h3 className="trip-dates-section__date">
                                    {checkinDate}
                                </h3>
                                <span className="check-in_date hidden-xs">
                                    <SVGIcon markup={ARROW_RIGHT__24} useFill />
                                </span>
                                {checkInTime && <h3>{checkInTime}</h3>}
                            </div>
                        </div>
                        <div className="trip-dates-section__departure">
                            <div className="trip-dates-section__date_time">
                                <div>
                                    {translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'stay.amenity.checkout'
                                    )}
                                </div>
                                <h3 className="trip-dates-section__date">
                                    {checkoutDate}
                                </h3>
                                {checkOutTime && <h3>{checkOutTime}</h3>}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
